import React, { useState, useEffect } from 'react';

interface ProgressBarProps {
    percent: number; // Yüzde değeri (0-100) belirlemek için kullanılır.
}

const ProgressBar: React.FC<ProgressBarProps> = ({ percent }) => {
    const [width, setWidth] = useState(0);

    useEffect(() => {
        if (percent >= 0 && percent <= 100) {
            setWidth(percent);
        }
    }, [percent]);

    return (
        <div className="progress-bar">
            <div
                className="progress-bar-fill"
                style={{ width: `${width}%` }}
            ></div>
        </div>
    );
};

export default ProgressBar;
